export function apiUrl(url) {
  if (process.browser) {
    return `/api/${url}`;
  }

  return `http://localhost:${process.env.PORT}/api/${url}`;
}
